import {Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import moment from 'moment-timezone';
import {UtilService} from '../../services/util/util.service';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss']
})
export class TimeInputComponent implements OnChanges {
  @ViewChild('timeInput') private _timeInput: ElementRef;

  private _time: string;
  public get time(): string {
    return this._time;
  }
  @Input()
  public set time(value: string) {
    this._time = value;
    if (this._time) {
      this._date = this._date
        .set('h', Number(this.time.substring(0, 2)))
        .set('m', Number(this.time.substring(3, 5)))
        .set('s', 0);
      this.timeChange.emit(this._time);
      this.dateChange.emit(this._date);
    } else {
      this.timeChange.emit(this._time);
    }
  }
  @Output() public timeChange: EventEmitter<string> = new EventEmitter<string>();

  private _date: moment.Moment;
  public get date(): moment.Moment {
    return this._date;
  }
  @Input()
  public set date(value: moment.Moment) {
    this._date = value;
    if (this._date?.isValid()) {
      const noDateTime: boolean = !(this._date.hours() + this._date.minutes() + this._date.seconds());
      if (this.time && noDateTime) {
        this._date = this._date
          .set('h', Number(this.time.substring(0, 2)))
          .set('m', Number(this.time.substring(3, 5)))
          .set('s', 0);
      } else {
        this._time = this.utilService.getTimeStringFromDate(this._date.format());
        this.timeChange.emit(this._time);
      }
    } else {
      this.time = null;
    }
  }
  @Output() public dateChange: EventEmitter<moment.Moment> = new EventEmitter<moment.Moment>();

  // Track if time was changed automatically or manually
  private _manualTime: boolean;
  @Input() public set manualTime(value: boolean) {
    this._manualTime = value;
    this.manualTimeChange.emit(this._manualTime);
  }
  public get manualTime(): boolean {
    return this._manualTime;
  }
  @Output() public manualTimeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() public label: string;
  @Input() public appClass: string;
  @Input() public hint: string;
  @Input() public valid = true;
  @Input() public error: string;
  @Input() public dynamicWidth: boolean;
  @Input() public disabled: boolean;
  @Input() public withPrefix: boolean;
  @Input() public withSuffix: boolean;

  @Input() public set focused(value: {modified: number, focus: boolean}) {
    if (value?.focus) {
      this._timeInput.nativeElement.focus();
    }
  }

  constructor(private utilService: UtilService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.timezone && !changes.timezone.firstChange) {
      this.time = this._time;
    }
  }
}
